module.exports = __webpack_public_path__ + "static/media/TANNIC.a19a1dfa.svg";